import { Translation } from '../types';

export const it: Translation = {
  common: {
    loading: 'Caricamento...',
    error: 'Errore',
    cancel: 'Annulla',
    save: 'Salva',
    close: 'Chiudi',
    search: 'Cerca',
    reload: 'Ricarica',
    logout: 'Esci',
    dashboard: 'Pannello di controllo',
    products: 'Prodotti',
    settings: 'Impostazioni',
    language: 'Lingua',
    businessHours: 'Orario di lavoro',
    back: 'Indietro',
    selectAll: 'Seleziona tutto',
    deselectAll: 'Deseleziona tutto',
    success: 'Successo',
    selected: 'Selezionati',
    confirm: 'Conferma',
    required: 'Obbligatorio',
    requiredMarker: '*',
    previous: 'Precedente',
    next: 'Successivo',
    allRightsReserved: 'Tutti i diritti riservati.',
  },
  auth: {
    login: 'Accesso',
    email: 'Indirizzo email',
    password: 'Password',
    loginButton: 'Accedi',
    loggingIn: 'Accesso in corso...',
    loginSuccess: 'Accesso riuscito',
    loginError: 'Email o password non corretti',
    invalidEmail: 'Email non valida',
    requiredFields: 'Compila tutti i campi',
    demoAccount: 'Account demo:',
    loginDescription: 'Accedi al tuo account',
    welcomeMessage: 'Benvenuto nel tuo spazio professionale',
    // Registration
    register: 'Registrati',
    createAccount: 'Crea account',
    confirmPassword: 'Conferma password',
    passwordRequirements: 'Min. 8 caratteri: maiuscole, minuscole, numeri e simboli',
    passwordsDoNotMatch: 'Le password non corrispondono',
    registrationSuccess: 'Registrazione riuscita',
    registrationDescription: 'Crea il tuo account professionale',
    alreadyHaveAccount: 'Hai già un account?',
    signIn: 'Accedi',
    dontHaveAccount: 'Non hai un account?',
    creatingAccount: 'Creazione account...',
    registrationNote: 'Nota:',
    registrationNotePoints: {
      erpLinking: 'Se hai un account aziendale esistente, la tua email verrà collegata automaticamente',
      companyEmail: 'Utilizza il tuo indirizzo email aziendale per la registrazione',
      contactSupport: 'Contatta il supporto se hai bisogno di assistenza per la registrazione'
    },
    b2bUsers: 'Clienti professionali:',
    registeredEmail: 'Indirizzo email registrato',
    registeredPassword: 'Password impostata durante la registrazione',
    b2bCustomerRequired: 'Email non riconosciuta. Contatta le vendite per aprire un account professionale.',
    b2bVerificationError: 'Errore di verifica. Contatta il supporto.',
    // Password Reset
    passwordReset: 'Reimpostazione password',
    passwordResetDescription: 'Ricevi una password temporanea via email',
    getTemporaryPassword: 'Ottieni password temporanea',
    processing: 'Elaborazione...',
    passwordResetComplete: 'Reimpostazione password completata',
    temporaryPasswordGenerated: 'È stata generata una password temporanea',
    temporaryPassword: 'Password temporanea',
    backToLogin: 'Torna al login',
    securityNotice: 'Avviso di sicurezza:',
    securityNotePoints: {
      keepSecret: 'Non condividere la password temporanea con altre persone',
      changeAfterLogin: 'Assicurati di cambiare la password dopo l\'accesso',
      expires24Hours: 'La password temporanea scade dopo 24 ore'
    },
    resetNote: 'Nota:',
    resetNotePoints: {
      registeredEmail: 'Inserisci il tuo indirizzo email registrato',
      passwordDisplayed: 'La password temporanea verrà visualizzata sullo schermo',
      changeRequired: 'Il cambio password è richiesto dopo l\'accesso'
    },
    copied: 'Copiato',
    copySuccessMessage: 'Password temporanea copiata negli appunti.',
    forgotPassword: 'Password dimenticata?',
    // Password Reset Email Request
    sendResetLink: 'Invia link di reimpostazione',
    sendingEmail: 'Invio email...',
    emailSent: 'Email inviata',
    emailSentMessage: 'Se questo indirizzo email esiste nel nostro sistema, riceverai un link di reimpostazione password a breve.',
    emailNotSent: 'Email non inviata',
    emailSentInfo: 'Controlla la tua casella di posta e la cartella spam',
    checkEmail: 'Controlla email',
    emailInstructions: 'Le istruzioni per la reimpostazione password sono state inviate',
    nextSteps: 'Prossimi passi:',
    nextStepsList: {
      checkInbox: 'Controlla la tua casella di posta e la cartella spam',
      clickLink: 'Clicca sul link di reimpostazione nell\'email',
      linkExpires: 'Il link scade in 24 ore',
      contactSupport: 'Contatta il supporto se non ricevi l\'email',
      rateLimitInfo: 'Limitato a 3 richieste per ora'
    },
    // Password Reset Completion
    resetLinkSent: 'Link di reimpostazione inviato',
    resetSuccess: 'Password reimpostata con successo',
    passwordUpdated: 'Password aggiornata',
    passwordUpdateMessage: 'La tua password è stata aggiornata con successo. Ora puoi accedere con la nuova password.',
    loginWithNewPassword: 'Accedi con nuova password',
    // Reset Token Page
    resetToken: 'Reimposta password',
    invalidToken: 'Token di reimpostazione non valido',
    expiredToken: 'Il token di reimpostazione è scaduto',
    tokenValid: 'Il token di reimpostazione è valido',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    updatePassword: 'Aggiorna password',
    updatingPassword: 'Aggiornamento password...',
    passwordMismatch: 'Le password non corrispondono',
    resetInstructions: 'Inserisci la nuova password per completare la reimpostazione',
  },
  accountInfo: {
    title: 'Informazioni account',
    loading: 'Caricamento...',
    error: 'Errore',
    errorMessage: 'Impossibile caricare le informazioni',
    back: 'Indietro',
    basicInfo: 'Dati personali',
    name: 'Nome',
    email: 'Indirizzo email',
    contactId: 'ID Cliente Knitido',
    contactNumber: 'Numero di contatto',
    noInfo: 'Non disponibile',
    companyInfo: 'Azienda',
    company: 'Azienda',
    position: 'Posizione',
    vatId: 'P.IVA',
    billingAddress: 'Indirizzo di fatturazione',
    deliveryAddress: 'Indirizzo di consegna',
    addressInfo: 'Indirizzi',
    billingDescription: 'Per fatture e contratti',
    deliveryDescription: 'Per consegne prodotti',
    sameAsBilling: '※ Stesso di fatturazione',
    sameAsDelivery: '※ Stesso di consegna',
    companyName: 'Nome azienda',
    contactPerson: 'Persona di contatto',
    address: 'Indirizzo',
    phoneNumber: 'Numero di telefono',
    billingUsage: 'Per fatture e documenti ufficiali',
    deliveryUsage: 'Per consegna ordini',
    alsoUsedForDelivery: 'Anche per consegne',
    accountType: 'Tipo di account',
    addressId: 'ID indirizzo',
    // Address editing functionality
    edit: 'Modifica',
    editDeliveryAddress: 'Modifica indirizzo di consegna',
    editDeliveryDescription: 'Modifica il tuo indirizzo di consegna',
    newDeliveryAddress: 'Aggiungi nuovo indirizzo di consegna',
    newDeliveryDescription: 'Inserisci i dettagli del tuo nuovo indirizzo di consegna',
    noDeliveryAddress: 'Nessun indirizzo di consegna configurato',
    success: 'Successo',
    addressUpdated: 'Indirizzo aggiornato',
    updateError: 'Errore aggiornamento',
    requiredFields: 'Compila tutti i campi richiesti',
    firstName: 'Nome',
    lastName: 'Cognome',
    streetAddress: 'Indirizzo',
    streetAddress2: 'Indirizzo 2',
    city: 'Città',
    country: 'Paese',
    selectCountry: 'Seleziona paese...',
    searchCountry: 'Cerca paese...',
    noCountryFound: 'Nessun paese trovato.',
    postalCode: 'Codice postale',
    companyNamePlaceholder: 'Inserisci il nome dell\'azienda',
    firstNamePlaceholder: 'Nome',
    lastNamePlaceholder: 'Cognome',
    streetAddressPlaceholder: 'Via e numero',
    streetAddress2Placeholder: 'Appartamento, scala (opzionale)',
    cityPlaceholder: 'Città',
    postalCodePlaceholder: 'Codice postale',
    billingNotEditable: 'Indirizzo fatturazione non modificabile.',
    billingContactSupport: 'Contatta il supporto per modifiche',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} indirizzi di consegna',
    noDeliveryAddresses: 'Nessun indirizzo di consegna registrato',
    defaultAddress: 'Predefinito',
    selectDeliveryAddress: 'Seleziona indirizzo di consegna',
    addNewAddress: 'Aggiungi nuovo indirizzo',
    editAddress: 'Modifica indirizzo',
    deleteAddress: 'Elimina indirizzo',
    confirmDelete: 'Conferma eliminazione',
    confirmDeleteMessage: 'Sei sicuro di voler eliminare questo indirizzo? Questa azione non può essere annullata.',
    addressAddedSuccess: 'Indirizzo di consegna aggiunto',
    addressDeletedSuccess: 'Indirizzo di consegna eliminato',
    deleteError: 'Impossibile eliminare l\'indirizzo di consegna',
    saving: 'Salvataggio...',
    cancel: 'Annulla',
    saveChanges: 'Salva modifiche',
    selectedDeliveryAddress: 'Indirizzo di consegna selezionato',
  },
  dashboard: {
    title: 'Partner commerciale',
    subtitle: 'Sistema ordini prodotti',
    welcome: 'Benvenuto,',
    welcomeMessage: 'Benvenuto! Ordina i tuoi prodotti in modo semplice.',
    productCatalog: 'Catalogo prodotti',
    productCatalogDesc: 'Esplora e ordina i nostri prodotti',
    viewProducts: 'Visualizza prodotti',
    orderHistory: 'Storico ordini',
    orderHistoryDesc: 'Consulta i tuoi ordini precedenti',
    accountSettings: 'Impostazioni account',
    accountSettingsDesc: 'Gestisci le tue informazioni',
    comingSoon: 'Prossimamente',
    infoTitle: 'Aiuto',
    orderingInfo: 'Ordinazione prodotti',
    orderingDesc: 'Scegli prodotti, taglie e colori. Stock in tempo reale.',
    supportInfo: 'Supporto',
    supportDesc: 'Domande? Contattaci.',
    viewOrderHistory: 'Storico',
    viewOrders: 'I miei ordini',
    accountInfo: 'Informazioni account',
    accountInfoDesc: 'Consulta le tue informazioni',
    viewDetails: 'Dettagli',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Lun-Ven 9h-15h CET',
    bulkImportDesc: 'Importa ordini da file Excel/CSV',
    importOrders: 'Importa ordini',
  },
  products: {
    title: 'Elenco prodotti',
    subtitle: 'Partner commerciale',
    searchPlaceholder: 'Nome prodotto o SKU...',
    productId: 'ID prodotto',
    addToCart: 'Aggiungi al carrello',
    selectVariation: 'Scegli variante',
    price: 'Prezzo',
    priceNetNotice: 'Prezzi al netto di tasse',
    stock: 'Inventario',
    color: 'Colore',
    newProducts: 'Nuovi Prodotti',
    newProductBadge: 'NUOVO',
    size: 'Taglia',
    quantity: 'Quantità',
    total: 'Totale',
    cart: 'Carrello',
    checkout: 'Procedi all\'ordine',
    csvMode: 'Modalità rapida CSV',
    csvInfo: 'Dati dal file CSV',
    csvUploadDate: 'Importato:',
    stockNote: '※ Stock aggiornato selezionando variante',
    noProducts: 'Nessun prodotto trovato',
    noProductsDesc: 'Modifica la ricerca o importa un file CSV.',
    retry: 'Riprova',
    pagination: 'articoli',
    variations: 'variazioni',
    stockFetchError: 'Errore stock',
    stockFetchFailed: 'Stock non disponibile',
    stockFetchFailedDesc: 'Stock non disponibile. Mostrando dati CSV.',
    stockFetched: 'Stock aggiornato',
    totalStock: 'Inventario totale',
    noStockAll: 'Nessun stock disponibile',
    noStockData: 'Dati stock assenti',
    stockFetchErrorDesc: 'Errore nel recupero stock',
    selectionError: 'Selezione errata',
    enterQuantity: 'Quantità richiesta',
    addedToCart: 'Aggiunto!',
    typesAdded: ' prodotti aggiunti',
    addToCartError: 'Errore nell\'aggiunta al carrello',
    addToCartErrorDesc: 'Si prega di riprovare',
    loadingStock: 'Verifica stock...',
    csvDataInfo: 'Dati CSV (stock non aggiornato)',
    filterByCategory: 'Filtra per categoria',
    allProducts: 'Tutti i prodotti',
    applyFilters: 'Applica filtri',
    clearFilters: 'Cancella filtri',
    filters: 'Filtri',
    clearAll: 'Cancella tutto',
    invalidDataFormat: 'Formato dati non valido',
    loadFailed: 'Errore di caricamento',
    csvUploadComplete: 'Importazione completata',
    csvLoadedDesc: ' prodotti importati. Stock aggiornato selezionando.',
    searchTitle: 'Ricerca prodotti',
    loadingProducts: 'Caricamento prodotti...',
    noProductsCsv: 'Nessun prodotto nel CSV. Modifica la ricerca.',
    paginationDisplay: ' mostrati',
    previous: 'Precedente',
    next: 'Successivo',
    selectionSummary: 'Riepilogo',
    selectedQuantity: 'Quantità selezionata',
    items: ' articoli',
    viewDetails: 'Dettagli',
    productImage: 'Immagine prodotto',
    correspondingVariations: 'Varianti disponibili',
    clickToEnlarge: 'Ingrandisci',
    productIdLabel: 'ID prodotto',
    colorLabel: 'Colore',
  },
  productDetail: {
    title: 'Dettagli prodotto',
    backToProducts: 'Torna ai prodotti',
    productNotFound: 'Prodotto non trovato',
    productNotFoundDesc: 'Prodotto non trovato o eliminato.',
    loading: 'Caricamento...',
    imageLoadError: 'Immagini non disponibili',
    noImages: 'Nessuna immagine disponibile',
    productDescription: 'Descrizione prodotto',
    colors: 'Colori',
    sizes: 'Taglie',
    colorCount: 'colori',
    sizeCount: 'taglie',
    variationCount: 'varianti',
    selectVariation: 'Scegli varianti',
    descriptionLanguageNote: '※ Descrizioni in inglese/tedesco',
  },
  colors: {
    schwarz: 'Nero',
    weiß: 'Bianco',
    grau: 'Grigio',
    rot: 'Rosso',
    blau: 'Blu',
    grün: 'Verde',
    gelb: 'Giallo',
    rosa: 'Rosa',
    lila: 'Viola',
    braun: 'Marrone',
    orange: 'Arancione',
    beige: 'Beige',
    navy: 'Blu navy',
    dunkelblau: 'Blu scuro',
    hellblau: 'Blu chiaro',
    dunkelgrau: 'Grigio scuro',
    hellgrau: 'Grigio chiaro',
    bordeaux: 'Bordeaux',
    türkis: 'Turchese',
    khaki: 'Cachi',
    mint: 'Menta',
    violett: 'Violetto',
    anthrazit: 'Antracite',
    blaugrau: 'Grigio blu',
    burgunderrot: 'Borgogna',
    elfenbein: 'Avorio',
    karminrot: 'Carminio',
    neongrün: 'Verde neon',
    gelbgrün: 'Verde giallo',
    pistazie: 'Pistacchio',
    // Nomi dei colori in inglese (usati in Product ID 237, ecc.)
    blue: 'Blu',
    ivory: 'Avorio',
    green: 'Verde',
    gold: 'Oro',
    red: 'Rosso',
  },
  categories: {
    category_21: 'Accessori',
    category_23: 'Calzini base',
    category_24: 'Offerte',
    category_29: 'B2B'
  },
  checkout: {
    title: 'Pagamento',
    cartReview: 'Verifica ordine',
    orderSummary: 'Riepilogo',
    shippingInfo: 'Informazioni di spedizione',
    billingInfo: 'Informazioni di fatturazione',
    orderNotes: 'Note ordine',
    orderNotesPlaceholder: 'Note o richieste speciali...',
    contactPerson: 'Persona di contatto',
    phoneNumber: 'Numero di telefono',
    email: 'Indirizzo email',
    company: 'Azienda',
    address: 'Indirizzo',
    city: 'Città',
    postalCode: 'Codice postale',
    country: 'Paese',
    deliveryDate: 'Data di consegna',
    urgentDelivery: 'Consegna express (3-5 giorni lavorativi)',
    standardDelivery: 'Consegna standard (7-10 giorni lavorativi)',
    placeOrder: 'Conferma ordine',
    backToCart: 'Torna al carrello',
    requiredField: 'Campo obbligatorio',
    orderTotal: 'Totale ordine',
    subtotal: 'Subtotale',
    priceNetNotice: 'Tutti i prezzi sono prezzi netti',
    stockReservationNotice: 'Stock riservato dopo conferma.',
    stockCheckError: 'Errore stock',
    stockCheckErrorDesc: 'Verifica fallita. Riprova.',
    shipping: 'Spedizione',
    shippingCost: 'Costo di spedizione',
    tax: 'Tassa',
    orderSuccess: 'Ordine confermato',
    orderSuccessMessage: 'Il tuo ordine è stato inviato con successo. Numero ordine: {orderNumber}',
    orderNumber: 'Numero ordine',
    thankYou: 'Grazie per il tuo ordine!',
    orderConfirmation: 'Ordine inviato!',
    orderProcessing: 'Conferma via email dopo validazione.',
    orderProcessingMessage: 'Ordine inviato. Conferma via email dopo validazione.',
    continueShopping: 'Continua lo shopping',
    emptyCart: 'Il tuo carrello è vuoto',
    emptyCartMessage: 'Aggiungi prodotti al carrello per continuare',
    stockWarning: 'Avviso stock',
    stockWarningDesc: 'Stock insufficiente. Modifica quantità.',
    stockError: 'Errore stock',
    stockErrorDesc: 'Stock insufficiente. Modifica quantità.',
    refreshStock: 'Aggiorna stock',
    stockUpdated: 'Stock aggiornato',
    stockUpdatedDesc: 'Stock aggiornato - {changed} modifiche',
    stockCheckDesc: 'Verifica stock completata',
    stockOk: 'Stock OK',
    stockShortage: 'Scorte insufficienti',
    requestedQty: 'Qtà richiesta',
    currentStock: 'Stock attuale',
    stockShortageMsg: 'Stock insufficiente. Modifica quantità.',
    stockIssueWarning: 'Ordine impossibile - stock insufficiente.',
    stockDataMissing: 'Verifica stock in corso...',
    outOfStock: 'Esaurito.',
    maxAvailable: 'Massimo',
    autoRestored: 'Carrello ripristinato',
    autoRestoredDesc: 'Gli articoli della tua ultima sessione sono stati ripristinati',
    maxQuantityReached: 'Quantità massima raggiunta.',
    // ERP Contact Search
    contactSearch: 'Ricerca contatto cliente',
    contactSearchDesc: 'Inserisci email del cliente',
    emailAddress: 'Indirizzo email',
    searchButton: 'Cerca',
    searching: 'Ricerca in corso',
    contactFound: 'Contatto trovato',
    contactNotFound: 'Contatto non trovato',
    contactId: 'ID Cliente Knitido',
    companyName: 'Azienda',
    contactPersonLabel: 'Persona di contatto',
    addressesFound: 'Indirizzi trovati',
    addressType: 'Tipo',
    addressBilling: 'Indirizzo di fatturazione',
    addressDelivery: 'Indirizzo di consegna',
    vatSourceCompany: 'Info azienda',
    vatSourceBilling: 'Fatturazione',
    vatSourceDelivery: 'Consegna',
    addressOther: 'Altro',
    addressDetails: 'Indirizzo',
    loadingAddresses: 'Caricamento indirizzi...',
    addressRetrieved: 'Indirizzo trovato',
    addressNotFound: 'Indirizzo non trovato',
    addressNotFoundDesc: 'Indirizzo non trovato. Inserire manualmente.',
    addressError: 'Errore indirizzo',
    addressErrorDesc: 'Impossibile caricare indirizzo.',
    contactNotConfirmed: 'Contatto cliente non confermato',
    contactNotConfirmedDesc: 'Cerca prima il contatto cliente.',
    searchContact: 'Cerca contatto',
    inputError: 'Errore inserimento',
    inputErrorDesc: 'Informazioni incomplete.',
    processing: 'Elaborazione...',
    erpContactSearch: 'Ricerca contatto cliente',
    contactSearchError: 'Email non riconosciuta.',
    // Product Images Toggle
    showProductImages: 'Mostra immagini prodotti',
    showProductImagesDesc: 'Visualizza foto prodotti (caricamento più lento)',
    // System Registration Info
    systemRegistrationInfo: 'Le tue informazioni cliente',
    editShippingAddress: 'Modifica indirizzo di consegna',
    systemRegistrationInfoDesc: 'I tuoi dati aziendali. Per modificare fatturazione, contatta il tuo rappresentante.',
    // Order Summary
    regularPrice: 'Prezzo all\'ingrosso regolare',
    offeredPrice: 'Prezzo offerto',
    discount: 'Sconto',
    b2bCustomer: 'Cliente B2B',
    pattern: 'Modello',
    specialPriceApplied: 'Prezzo speciale applicato',
    customerClassification: 'Classificazione cliente',
    paymentCondition: 'Termini di pagamento',
    invoice: 'Fattura (NET 30)',
    prepayment: 'Pagamento anticipato',
    paymentMethod: 'Metodo di pagamento',
    invoicePayment: 'Pagamento con fattura',
    estimatedSubtotal: 'Subtotale stimato',
    estimatedTotal: 'Totale stimato',
    orderSummaryDisclaimer: 'Prezzi stimati. Conferma finale con prezzi, spedizione e tasse via email.',
    searchError: 'Errore di ricerca',
    searchErrorDesc: 'Si è verificato un errore durante la ricerca del contatto.',
    confirmDeleteItem: 'Rimuovi articolo',
    itemDeleted: 'Articolo rimosso',
    confirmDeleteItemDesc: 'Rimuovere questo articolo dal carrello?',
    deleteConfirm: 'Rimuovi',
    contactNotes: 'Note di contatto',
    contactNotesDesc: 'Domande o richieste speciali? (opzionale)',
    contactNotesLabel: 'Messaggio',
    contactNotesPlaceholder: 'Es: domande prodotti, requisiti speciali...',
    characters: 'caratteri',
    contactIdLabel: 'ID Cliente Knitido',
    companyLabel: 'Azienda',
    personLabel: 'Persona di contatto',
    emailLabel: 'Email',
    addressTypeLabel: 'Tipo',
    destinationLabel: 'Destinazione',
    // Shipping Form
    shippingTitle: 'Informazioni di spedizione',
    shippingDesc: 'Dove consegnare i prodotti?',
    companyRequired: 'Azienda *',
    contactPersonRequired: 'Persona di contatto *',
    emailRequired: 'Indirizzo email *',
    phoneRequired: 'Numero di telefono *',
    addressRequired: 'Indirizzo 1 *',
    address2: 'Complemento (Edificio/App.)',
    postalCodeRequired: 'Codice postale *',
    cityRequired: 'Città *',
    countryRequired: 'Paese *',
    selectCountry: 'Seleziona paese',
    shippingMethodRequired: 'Metodo di spedizione *',
    selectShippingMethod: 'Seleziona metodo di spedizione',
    urgentDeliveryOption: 'Express (costo aggiuntivo)',
    deliveryNotes: 'Note di consegna',
    deliveryNotesPlaceholder: 'Preferenze di consegna...',
    standardShipping: 'Spedizione standard (3-5 giorni lavorativi)',
    expressShipping: 'Spedizione express (1-2 giorni lavorativi)',
    overnightShipping: 'Spedizione notturna',
    germany: 'Germania',
    austria: 'Austria',
    switzerland: 'Svizzera',
    japan: 'Giappone',
    shippingAddressLabel: 'Indirizzo di consegna',
    changeDeliveryAddress: 'Modifica indirizzo di consegna',
    selectDeliveryAddress: 'Seleziona indirizzo di consegna',
    // Shipping Cost Details
    freeShipping: 'Spedizione gratuita',
    shippingError: 'Errore',
    shippingZone: 'Zona di spedizione',
    remainingForFreeShipping: '{amount} in più per la spedizione gratuita',
    moreForFreeShipping: 'per la spedizione gratuita',
    freeShippingProgress: 'Spedizione gratuita a',
    andAboveFreeShipping: 'e oltre per spedizione gratuita',
    freeShippingAchieved: 'Spedizione gratuita applicata',
    threshold: 'e oltre',
    nextShippingTier: 'Prossimo sconto spedizione',
    moreForDiscount: 'in più per',
    shippingSavings: 'risparmio spedizione',
    orderAmountThreshold: 'e oltre per',
    specialRegionNotice: 'Regione di spedizione speciale applicata',
    defaultShippingApplied: 'Tariffe di spedizione standard applicate',
    requestedQuantity: 'Quantità richiesta',
    availableQuantity: 'Quantità disponibile',
    orderSubmitError: 'Errore nell\'invio dell\'ordine',
    orderSubmitErrorDesc: 'Impossibile inviare l\'ordine',
    upload: {
      title: 'Importa ordine Excel/CSV',
      description: 'Carica un file Excel o CSV con i dati del tuo ordine',
      dragDropOrClick: 'Trascina e rilascia il file qui o clicca per selezionare',
      dropHere: 'Rilascia il file qui',
      supportedFormats: 'Formati supportati: Excel (.xlsx, .xls) e CSV (.csv)',
      maxSize: 'Dimensione massima file: {size} MB',
      processFile: 'Elabora file',
      processing: 'Elaborazione file...',
      ready: 'File pronto per anteprima',
      readyDescription: 'Il tuo file è stato elaborato con successo ed è pronto per la revisione.',
      preview: 'Mostra anteprima',
      errors: {
        fileTooLarge: 'File troppo grande. Dimensione massima: {size} MB',
        invalidFileType: 'Tipo di file non valido. Carica un file Excel o CSV',
        uploadFailed: 'Errore nel caricamento del file',
      },
    },
    // Loading messages
    loadingPage: 'Caricamento...',
    loadingStock: 'Verifica stock...',
    loadingAccount: 'Caricamento account...',
    loadingError: 'Errore di caricamento',
    loadingData: 'Caricamento dati',
    // Toast messages
    addressRetrievedTitle: 'Indirizzo trovato',
    addressSetAsDelivery: ' sarà l\'indirizzo di consegna.',
    contactFoundDesc: ' identificato.'
  },
  orderHistory: {
    title: 'Storico ordini',
    searchPlaceholder: 'N° ordine o SKU...',
    noOrders: 'Nessun ordine trovato',
    noOrdersFound: 'Nessun risultato',
    startShopping: 'Vedi prodotti',
    orderItems: 'Articoli dell\'ordine',
    viewDetails: 'Dettagli',
    reorder: 'Riordina',
    orderDate: 'Data ordine',
    orderStatus: 'Stato',
    orderTotal: 'Totale ordine',
    // Status translations
    statusPending: 'Pagamento in sospeso',
    statusProcessing: 'In elaborazione',
    statusConfirmed: 'Confermato',
    statusShipped: 'Spedito',
    statusDelivered: 'Consegnato',
    statusCancelled: 'Annullato',
    statusReturned: 'Restituito',
    statusRefunded: 'Rimborsato',
    statusWarranty: 'In garanzia',
    statusExchanged: 'Scambiato',
    statusRepair: 'In riparazione',
    statusUnknown: 'Sconosciuto',
    statusIncomplete: 'Incompleto',
    statusWaitingPayment: 'In attesa di pagamento',
    statusInPreparation: 'In preparazione',
    statusClearedShipping: 'Pronto per la spedizione',
    statusBeingShipped: 'In fase di spedizione',
    statusOutgoingBooked: 'Spedizione prenotata',
    statusReturn: 'Reso',
    // Additional UI elements
    itemCount: 'articoli',
    itemCountSingular: 'articolo',
    refreshButton: 'Aggiorna',
    errorFetchingOrders: 'Errore caricamento storico',
    // Payment status features
    paymentStatus: 'Stato del pagamento',
    markAsPaid: 'Segna come pagato',
    unmarkAsPaid: 'Rimuovi segno pagato',
    paidOn: 'Pagato il',
    paymentMarked: 'Pagato',
    notPaid: 'Non pagato',
    paymentMarkedSuccess: 'Segnato come pagato',
    paymentUnmarkedSuccess: 'Segno pagato rimosso',
    paymentUpdateError: 'Errore durante l\'aggiornamento dello stato del pagamento',
    // Payment date dialog
    paymentDateTitle: 'Inserisci informazioni di pagamento',
    paymentDateDescription: 'Inserisci le informazioni di pagamento per l\'ordine {orderNumber}',
    paymentDateLabel: 'Data di pagamento',
    selectDate: 'Seleziona data',
    paymentDateHelp: 'Seleziona la data del bonifico bancario',
    paymentMethodLabel: 'Metodo di pagamento',
    bankTransfer: 'Bonifico bancario',
    invoice: 'Fattura',
    otherPayment: 'Altro',
    paymentReferenceLabel: 'Riferimento pagamento',
    paymentReferencePlaceholder: 'es. Bonifico del 01/01/2024',
    paymentReferenceHelp: 'Inserisci informazioni per facilitare la riconciliazione',
    notesLabel: 'Note',
    notesPlaceholder: 'Informazioni aggiuntive sul pagamento',
    // Filter options
    filterByPaymentStatus: 'Filtra per stato pagamento',
    allOrders: 'Tutti gli ordini',
    paidOrders: 'Pagati',
    unpaidOrders: 'Non pagati',
    // Sorting options
    sortBy: 'Ordina per',
    sortByDate: 'Data ordine',
    sortByPaymentDate: 'Data pagamento',
    sortByAmount: 'Importo',
    sortByStatus: 'Stato',
  },
  orderDetails: {
    title: 'Dettagli ordine',
    notFound: 'Ordine non trovato',
    backToHistory: 'Torna allo storico',
    orderDate: 'Data ordine',
    orderItems: 'Articoli dell\'ordine',
    deliveryStatus: 'Stato consegna',
    estimatedDelivery: 'Consegna stimata',
    deliveredOn: 'Consegnato il',
    downloadInvoice: 'Scarica fattura',
    statusDelivered: 'Consegnato',
    statusShipped: 'Spedito',
    statusConfirmed: 'Confermato',
    statusCancelled: 'Annullato',
    errorFetchingDetails: 'Errore caricamento dettagli',
  },
  company: {
    name: 'Partner commerciale',
    tagline: 'Piattaforma professionale',
    copyright: '© 2025 Knitido. Tutti i diritti riservati.',
  },
  footer: {
    phone: 'Telefono',
    email: 'Email',
    countries: {
      DE: 'Germania',
      AT: 'Austria',
      CH: 'Svizzera',
      FR: 'Francia',
      IT: 'Italia',
      ES: 'Spagna',
      NL: 'Paesi Bassi',
      BE: 'Belgio',
      PL: 'Polonia',
      SE: 'Svezia',
      NO: 'Norvegia',
      FI: 'Finlandia',
      DK: 'Danimarca',
      LT: 'Lituania',
      LV: 'Lettonia',
      EE: 'Estonia',
    },
  },
  cart: {
    newCart: 'Nuovo carrello',
    currentCart: 'Carrello attuale',
    modified: 'modificato',
    lastSaved: 'Ultimo salvataggio',
    unsavedChanges: 'non salvato',
    saveCart: 'Salva carrello',
    loadCart: 'Carica carrello',
    deleteCart: 'Elimina carrello',
    startNewCart: 'Nuovo carrello',
    savedCarts: 'Carrelli salvati',
    cartSaved: 'Carrello salvato',
    cartDeleted: 'Carrello eliminato',
    confirmDeleteCart: 'Eliminare questo carrello?\n\nAzione irreversibile.',
    confirmSwitchCart: 'Carrello non salvato.\n\nLe modifiche andranno perse.\n\nContinuare?',
    confirmSwitchCartTitle: 'Cambia carrello',
    confirmNewCart: 'Carrello non salvato.\n\nLe modifiche andranno perse.\n\nContinuare?',
    confirmNewCartTitle: 'Inizia nuovo carrello',
    confirmClearCart: 'Svuotare carrello?\n\n{count} articoli eliminati.\n\nAzione irreversibile.',
    confirmClearCartTitle: 'Svuota carrello',
    autoSaved: 'Salvataggio automatico',
    itemsWillBeRemoved: 'articoli eliminati',
    changesWillBeLost: 'modifiche perse',
    continueQuestion: 'Continuare?',
    cartStatus: 'Stato del carrello',
    cartName: 'Nome del carrello',
    cartNamePlaceholder: 'Es: Ordine marzo 2025',
    cartNameRequired: 'Nome richiesto',
    saveCartDescription: 'Nomina e salva questo carrello per dopo.',
    cancelCart: 'Annulla carrello',
    proceedToCheckout: 'Procedi al checkout',
    emptyCart: 'Il carrello è vuoto',
    erpDown: 'Il sistema degli ordini è inattivo. Riprova più tardi.',
    erpDegraded: 'Il sistema è attualmente instabile. Gli ordini potrebbero fallire.',
    erpDownSaveHint: 'Salva il carrello e ordina quando il sistema è ripristinato.',
    erpSaveCart: 'Salva carrello',
  },
  nav: {
    dashboard: 'Home',
    products: 'Prodotti',
    orderHistory: 'I miei ordini',
    account: 'Il mio account',
    bulkImport: 'Importazione multipla',
  },
  settings: {
    selectLanguage: 'Scegli lingua',
    languagePreferenceSaved: 'Lingua salvata per le prossime visite.',
  },
  reorder: {
    allItemsAdded: '{count} articoli aggiunti al carrello',
    partialSuccess: '{added} articoli aggiunti. {failed} articoli non possono essere aggiunti',
    allItemsFailed: 'Impossibile aggiungere gli articoli al carrello',
    error: 'Si è verificato un errore durante il riordino',
    itemDiscontinued: '{name} ({color}/{size}) è stato discontinuato',
    itemOutOfStock: '{name} ({color}/{size}) è esaurito',
    partialStock: '{name} ({color}/{size}) solo {available} disponibili',
    confirmReorder: 'Conferma riordino',
    confirmReorderMessage: 'Aggiungere gli articoli di questo ordine al carrello?',
    addingToCart: 'Aggiunta al carrello...',
    checkingStock: 'Verifica disponibilità...',
    checkoutTitle: 'Articoli aggiunti al carrello',
    checkoutDescription: '{count} articoli aggiunti al carrello. Vuoi procedere al checkout?',
  },
  bulkImport: {
    instructions: 'Come importare ordini',
    step1: 'Scarica il file modello per gli ordini',
    step2: 'Inserisci i tuoi dati ordine con SKU e quantità',
    step3: 'Salva come file Excel (.xlsx) o CSV',
    step4: 'Carica il file usando il modulo sottostante',
    step5: 'Rivedi e conferma il tuo ordine',
    downloadTemplate: 'Scarica modello',
    formatGuide: 'Guida formato file',
    requiredColumns: 'Colonne obbligatorie',
    skuDescription: 'Codice SKU del prodotto',
    quantityDescription: 'Quantità ordine (numero intero positivo)',
    optionalColumns: 'Colonne opzionali',
    notesDescription: 'Note interne (es: n° PO, riferimenti) - solo per i vostri archivi',
    formatNote: 'La prima riga deve contenere le intestazioni delle colonne. I dati iniziano dalla seconda riga.',
    parseSuccess: 'Elaborati con successo {count} articoli dal file',
    parseError: 'Errore di analisi',
    validationError: 'Errori di validazione',
    validationErrorGuidance: 'Si prega di fare clic sul pulsante «{showPreviewButton}» per rivedere i dettagli.',
    warnings: 'Avvisi',
    itemsParsed: 'Elaborati con successo {count} articoli:',
    andMore: '...e altri {count} articoli',
    validationSummary: 'Riepilogo validazione',
    duplicateSKUs: 'SKU duplicati trovati',
    skuFormat: 'SKU deve contenere solo lettere, numeri e trattini',
    quantityRange: 'La quantità deve essere compresa tra 1 e 9999',
    maxRows: 'Massimo 1000 righe consentite',
    rowsSkipped: '{count} righe sono state saltate a causa di errori',
    previewTitle: 'Anteprima ordine',
    previewDescription: 'Rivedi e modifica i dati del tuo ordine prima di procedere',
    proceedToCart: 'Aggiungi al carrello',
    // File parsing messages
    fileEmpty: 'Il file è vuoto o non contiene dati',
    fileTooManyRows: 'Il file contiene troppe righe ({current}). Massimo consentito: {max}',
    invalidRowFormat: 'Formato riga non valido',
    missingColumns: 'Colonne obbligatorie mancanti (SKU e Quantità)',
    missingSku: 'SKU mancante',
    invalidSkuFormat: 'Formato SKU non valido: "{sku}" (deve corrispondere al pattern: {pattern})',
    skuTooLong: 'SKU troppo lungo: "{sku}" (massimo 50 caratteri)',
    invalidQuantity: 'Quantità non valida: "{quantity}" non è un numero',
    quantityTooLow: 'Quantità troppo bassa: {quantity} (minimo: {min})',
    quantityTooHigh: 'Quantità troppo alta: {quantity} (massimo: {max})',
    notesRequired: 'Il campo note è obbligatorio',
    noValidData: 'Nessun dato valido trovato. Controlla il formato del file.',
    row: 'Riga {row}: {errors}',
    rowErrors: '...e altri {count} errori',
    duplicateSkuInRows: 'SKU duplicato "{sku}" trovato nelle righe: {rows}',
    quantityExceedsMax: 'Riga {row}: Quantità {quantity} supera il massimo consentito ({max})',
    quantityBelowMin: 'Riga {row}: Quantità {quantity} è inferiore al minimo richiesto ({min})',
    // Validation messages
    unsupportedFileFormat: 'Formato file non supportato. Carica un file CSV o Excel.',
    csvParsingErrors: 'Si sono verificati errori nell\'analisi del CSV',
    failedToParseFile: 'Impossibile analizzare il file',
    failedToParseExcel: 'Impossibile analizzare il file Excel',
    failedToReadFile: 'Impossibile leggere il file',
    unknownError: 'Si è verificato un errore sconosciuto',
    totalRows: 'Righe totali',
    valid: 'Valide',
    invalid: 'Non valide',
    skipped: 'Saltate',
    // SKU validation
    skuValidationError: 'Errore validazione SKU',
    skuValidationFailed: 'Validazione SKU fallita. Puoi comunque procedere ma alcuni articoli potrebbero non essere disponibili.',
    skuNotFound: 'SKU non trovato nel database',
    skusNotFound: '{count} SKU non trovati nel database',
    itemsHaveInsufficientStock: '{count} articoli hanno scorte insufficienti',
    validatingSKUs: 'Verifica articoli...',
    unvalidatedChanges: 'Hai modifiche non validate. Si prega di rivalidare prima di aggiungere al carrello.',
    revalidate: 'Rivalidare',
    validating: 'Validazione...',
    validationSuccess: 'Tutti gli articoli sono validi',
    validationComplete: 'Validazione completata',
    validationResultSummary: '{errors} errori, {warnings} avvertenze trovate',
    // Table headers
    actions: 'Azioni',
    notes: 'Note',
    // Status filter
    all: 'Tutti',
    hasErrors: 'Con errori',
    // Selection summary
    selected: 'selezionati',
    errors: 'errori',
    // Pagination
    page: 'Pagina {current} di {total}',
    previous: 'Precedente',
    next: 'Successivo',
    noResults: 'Nessun risultato.',
    // Cart integration
    noValidItems: 'Nessun articolo valido',
    allItemsHaveErrors: 'Tutti gli articoli hanno errori di validazione. Correggili prima di procedere.',
    dataLoadingError: 'Errore caricamento dati',
    failedToLoadProductData: 'Impossibile caricare i dati dei prodotti. Riprova.',
    itemsAddedToCart: '{count} articoli aggiunti al carrello',
    itemsAddedMessage: 'Aggiunti {count} articoli al carrello',
    someSkusNotFound: '{count} SKU non sono stati trovati.',
    noItemsAdded: 'Nessun articolo aggiunto',
    couldNotFindProducts: 'Impossibile trovare prodotti corrispondenti agli SKU.',
    errorAddingToCart: 'Errore',
    failedToAddToCart: 'Impossibile aggiungere articoli al carrello. Riprova.',
    addingToCart: 'Aggiunta al carrello...',
    // File info
    fileSelected: '{name} selezionato per l\'elaborazione',
    fileSize: '{size} byte',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Download modello',
    templateWillBeImplemented: 'Il download del modello sarà implementato nella Fase 7',
    // Additional validation
    validationFailed: 'Validazione fallita',
    // Template download
    templateDownloaded: 'Modello scaricato con successo',
    templateDownloadError: 'Errore nel download del modello',
    downloadExcelTemplate: 'Scarica modello Excel',
    downloadCsvTemplate: 'Scarica modello CSV',
    // Template content
    sheetName: 'Ordine multiplo',
    instructionsSheetName: 'Istruzioni',
    columnDescriptions: 'Descrizioni colonne:',
    columnHeader: 'Colonna',
    columnRequired: 'Obbligatorio',
    columnOptional: 'Opzionale',
    columnDescription: 'Descrizione',
    templateNotes: 'Note:',
    templateNote1: 'La prima riga deve contenere le intestazioni delle colonne esattamente come mostrato',
    templateNote2: 'I dati iniziano dalla riga 2',
    templateNote3: 'Lo SKU deve corrispondere ai codici prodotto esistenti nel sistema',
    templateNote4: 'La quantità deve essere un numero intero positivo tra 1 e 9999',
    templateNote5: 'Massimo 1000 righe consentite per file',
    templateNote6: 'Salvare in formato .xlsx o .csv',
    stockAvailabilityWarning: 'La disponibilità effettiva delle scorte verrà verificata nella prossima pagina di checkout.',
    outOfStock: 'Esaurito',
    insufficientStock: 'Stock insufficiente: {available} disponibile, {requested} richiesto',
  },
  orderExport: {
    export: 'Esporta ordine',
    exportOrder: 'Esporta dati ordine',
    exportAsCSV: 'Esporta come CSV',
    exportAsExcel: 'Esporta come Excel',
    exportForReorder: 'Esporta per importazione multipla',
    detailed: 'Dettagli completi',
    simpleFormat: 'Formato importazione',
  },
};